import { Box, Typography } from '@mui/material';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';

export default function NoRowsOverlay() {
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            px: 2,
            py: 1.5,
            mx: 2,
            mt: 2,
            borderRadius: 1,
            backgroundColor: '#fff5f5',
            border: '1px solid #ffcdd2',
            color: 'error.main',
            alignSelf: 'flex-start',
        }}>
            <FilterAltOffIcon sx={{ fontSize: 20 }} />
            <Box>
                <Typography variant="body2" fontWeight={600}>No forms found</Typography>
                <Typography variant="caption" sx={{ color: 'error.light' }}>
                    No contested case forms have been submitted
                </Typography>
            </Box>
        </Box>
    );
}